import { render } from "./recruitTeacher.vue?vue&type=template&id=56f22560&scoped=true"
import script from "./recruitTeacher.vue?vue&type=script&lang=js"
export * from "./recruitTeacher.vue?vue&type=script&lang=js"

import "./recruitTeacher.vue?vue&type=style&index=0&id=56f22560&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f22560"]])

export default __exports__